/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "商品大图",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
            key: "image_url",
            name: "封面图片",
            type: "img",
            memo: "建议宽度：750px*360px"
        }]
    },
    {
        key: "link_data",
        name: "链接",
        type: "item-sale"
    }
];

export default config;